"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _makeStyles = _interopRequireDefault(require("@material-ui/styles/makeStyles"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var styles = (0, _makeStyles.default)(function (theme) {
  return {
    checkbox: {
      flex: "0 0 100%",
      "& .MuiTextField-root": {
        width: "100%"
      }
    },
    checkboxError: {
      color: theme.palette.error.main,
      "& svg": {
        fill: theme.palette.error.main
      }
    }
  };
});
var _default = styles;
exports.default = _default;